module.exports = __webpack_public_path__ + "assets/img/kv-f44ec344.jpg";